import { StandardLink } from 'components/links/StandardLink';

export function NativeAppLauncherPage() {
  return (
    <>
      <h1>Please visit this link on an iOS device with the Cerego app installed</h1>
      <div className="mt-6">
        Alternatively, you can{' '}
        <StandardLink hardRedirect={true} to="/app/nav/v4/dashboard">
          visit the Cerego web dashboard
        </StandardLink>
      </div>
    </>
  );
}
